import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { AuthService } from "src/app/core/service/auth.service";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { LanguageService } from "src/app/core/service/language.service";
// import { HospitalService } from '../../hospital/shared/hospital.service';
import { TranslateService } from "@ngx-translate/core";
import { PatientService } from "src/app/patient/Shared/patient.service";
import { PharmacyService } from "../../pharmacy/shared/pharmacy.service"
import { DoctorService } from "src/app/doctor/shared/doctor.service";
import { environment } from "src/environments/environment";
const document: any = window.document;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  flagvalue;
  countryName;
  end_point = environment.imageUrl;
  langStoreValue: string;
  defaultFlag: string;
  notification_list_count: any;
  totalSize: any;
  cart_details: any;
  total: any;
  isSideMenuClosed = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private dataService: RightSidebarService,
    private configService: ConfigService,
    public authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    private notificationAPI: DoctorService,
    private translate: TranslateService,
    private cartlistapi: PatientService,
    private api: PharmacyService
  ) { }
  listLang = [
    { text: "English", flag: "assets/images/flags/us.jpg", lang: "en" },
    { text: "french", flag: "assets/images/flags/french.png", lang: "fr" },
    // { text: "Spanish", flag: "assets/images/flags/spain.jpg", lang: "es" },
    // { text: "German", flag: "assets/images/flags/germany.jpg", lang: "de" },
  ];
  notifications: any[] = [
    {
      userImg: "assets/images/user/user1.jpg",
      userName: "Sarah Smith",
      time: "14 mins ago",
      message: "Please check your mail",
    },
    {
      userImg: "assets/images/user/user2.jpg",
      userName: "Airi Satou",
      time: "22 mins ago",
      message: "Work Completed !!!",
    },
    {
      userImg: "assets/images/user/user3.jpg",
      userName: "John Doe",
      time: "3 hours ago",
      message: "kindly help me for code.",
    },
    {
      userImg: "assets/images/user/user4.jpg",
      userName: "Ashton Cox",
      time: "5 hours ago",
      message: "Lets break for lunch...",
    },
    {
      userImg: "assets/images/user/user5.jpg",
      userName: "Sarah Smith",
      time: "14 mins ago",
      message: "Please check your mail",
    },
    {
      userImg: "assets/images/user/user6.jpg",
      userName: "Airi Satou",
      time: "22 mins ago",
      message: "Work Completed !!!",
    },
    {
      userImg: "assets/images/user/user7.jpg",
      userName: "John Doe",
      time: "3 hours ago",
      message: "kindly help me for code.",
    },
  ];
  ngOnInit() {
    this.config = this.configService.configData;
    let userRole
    let image
    this.authService.currentUserSubject.subscribe(res => {
      if (this.authService.currentUserValue) {
        userRole = this.authService.currentUserValue.user_role;
        this.userImg = this.end_point + this.authService.currentUserValue.picture;
        // image = this.end_point + this.authService.currentUserValue.picture
        // console.log(this.userImg)

      }
    })

    if (userRole === "Admin") {
      this.homePage = "admin/dashboard/main";
    } else if (userRole === "Patient") {
      this.homePage = "patient/dashboard";
    } else if (userRole === "Doctor") {
      this.homePage = "doctor/dashboard";
    } else if (userRole === "Hospital") {
      this.homePage = "hospital/dashboard";
    } else if (userRole === "medical_store") {
      this.homePage = "pharmacy/dashboard";
    } else if (userRole === "drug_store") {
      this.homePage = "pharmacy/dashboard";
    }

    else {
      this.homePage = "admin/dashboard/main";
    }

    this.langStoreValue = localStorage.getItem("lang");
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = "assets/images/flags/us.jpg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    // this.notification_list()
    this.cart_list()
    this.notificationpharmacy_list()
    this.notification_list()

  }


  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader")
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
  }
  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      this.isSideMenuClosed = false;
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      this.isSideMenuClosed = true;
    }
  }
  public toggleRightSidebar(): void {
    this.dataService.changeMsg(
      (this.dataService.currentStatus._isScalar = !this.dataService
        .currentStatus._isScalar)
    );
  }
  logout() {

    if (this.authService.currentUserValue.role == 'Admin') {
      this.authService.logout().subscribe((res) => {
        if (!res.success) {
          this.router.navigate(["/authentication/admin-signin"]).then(() => {
            window.location.reload();
          });
        }
      });
    } else if (this.authService.currentUserValue.user_role == 'medical_store') {
      localStorage.removeItem('authentication_token');
      this.authService.logout().subscribe((res) => {
        if (!res.success) {
          this.router.navigate(["/authentication/pharmacy-signin"]).then(() => {
            window.location.reload();
          });
        }
      });
    } else {
      this.authService.logout().subscribe((res) => {
        if (!res.success) {
          this.router.navigate(["/authentication/signin"]).then(() => {
            window.location.reload();
          });
        }
      });
    }
  }
  notification_list() {
    const form_data = new FormData();
    form_data.append('receiver_id', this.authService.currentUserValue.id);
    form_data.append('receiver_type', this.translate.currentLang)
    form_data.append('page_no', '1');
    this.notificationAPI.doctor_notification(form_data).then((status: any) => {
      // console.log('Response:', status);
      this.notification_list_count = status.notifications;
      this.totalSize = status['unread_notification_count']
      // console.log(this.totalSize)
    }).catch((error: any) => {
    });
  }
  cart_list() {
    const form_data = new FormData();
    if (this.authService.currentUserValue.user_role == "Patient") {
      form_data.append('page_no', '1')
      this.cartlistapi.get_Cart_Details(form_data).then((status: any) => {
        // console.log('Response:', status);
        this.cart_details = status.list;
        this.total = status.total
        // console.log(this.total)
      }).catch((error: any) => {
      });
    }

  }
  notificationpharmacy_list() {
    let currentUser = JSON.parse(localStorage.currentUser)
    // console.log(currentUser)
    const form_data = new FormData();
    form_data.append('receiver_id', currentUser.store_id);
    form_data.append('receiver_type', currentUser.user_rolez)
    form_data.append('page_no', '1');
    this.api.pharmacy_notification(form_data).then((status: any) => {
      // console.log('Response:', status);
      this.notification_list_count = status.notifications;
      // console.log(this.notification_list_count)

      // this.totalSize = status['unread_notification_count']
      this.totalSize = status['total']
      // console.log(this.totalSize)
    }).catch((error: any) => {
    });
  }
}

